var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(_vm.cmpName,{tag:"component",attrs:{"init-id":_vm.biz.bizId,"init-data":_vm.biz.bizData,"opener":_vm.opener}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }